/** Complete CSS hex colors, always stored with a leading #. */
export const HEX_COLOR_PATTERN = '^#(?:[0-9a-fA-F]{3,4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$';

const COMPLETE_HEX = new RegExp(HEX_COLOR_PATTERN);

export function isHexColor(value: unknown): value is string {
  return typeof value === 'string' && value.trim() === value && COMPLETE_HEX.test(value);
}

/** Validates the whole input; never strips characters or truncates alpha. */
export function normalizeHexColorInput(value: string): string | null {
  const hex = value.startsWith('#') ? value : `#${value}`;
  return isHexColor(hex) ? hex : null;
}

/** Reapplies stored alpha after the native RGB-only picker changes, without percentage rounding. */
export function preserveHexColorAlpha(rgb: string, color: string): string {
  if (!isHexColor(color)) return rgb;
  if (color.length === 5) return `${rgb}${color[4]}${color[4]}`;
  if (color.length === 9) return `${rgb}${color.slice(7)}`;
  return rgb;
}

/** Native color inputs require six RGB digits; alpha remains in the stored color. */
export function hexColorSwatchValue(value: string, fallback: string): string {
  if (!isHexColor(value)) return fallback;
  if (value.length === 4 || value.length === 5) {
    return `#${value[1]}${value[1]}${value[2]}${value[2]}${value[3]}${value[3]}`;
  }
  return value.slice(0, 7);
}
